import React from 'react'
import { useEmployeFilter } from '../../context/EmployeFilterContext';
import { Dropdown } from "primereact/dropdown";
import { useEmployeeDetail } from '../../Hooks/Features/employeeDashboard/useEmployeeDetail';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog } from "primereact/dialog";
import { DateTime } from 'luxon';
import { SkeletonProfile } from '../Loader/Loader';
import Profile from '../Profile/Profile';

const EmployeInfo = () => {

    const { selectedEmployee, setSelectedEmployee } = useEmployeFilter();
    const { users, viewProfileDialog, setViewProfileDialog, employeeData, loader, skills, loggedInUser, isLeadDashboard, punctualityData, userImage } = useEmployeeDetail();

    const employeeDetails = [
        { label: "Employee ID", value: employeeData?.employee_id || "-" },
        { label: "Primary Project", value: employeeData?.primary_project || "-" },
        { label: "Sec. Project", value: employeeData?.secondary_project || "-" },
        {
            label: "Join", value: (
                <>
                    {employeeData?.joining_date && (DateTime.fromISO(employeeData?.joining_date).toFormat('dd LLL yyyy') || "-")}
                    <br />
                    {employeeData?.tenure && `(${employeeData?.tenure})`}
                </>
            )
        },
        { label: "Business Unit", value: employeeData?.business_unit || "-" },
        { label: "SBU", value: employeeData?.sub_business_unit || "-", title: "Sub Business Unit" },
    ];

    const punctualityDetails = [
        { title: "Action Accuracy", icon: "bolt", value: "" },
        { title: "Timesheet Accuracy", icon: "clock", value: punctualityData?.["Timesheet"]?.[0]?.valueLabel },
        { title: "Unpunctuality", icon: "user-clock", value: punctualityData?.["Unpunc."]?.[0]?.valueLabel },
        { title: "WFH", icon: "house-laptop", value: punctualityData?.["WFH"]?.[0]?.valueLabel },
        { title: "Gate Pass", icon: "id-badge", value: punctualityData?.["Gate Pass"]?.[0]?.valueLabel?.split("(")?.[0], tooltip: punctualityData?.["Gate Pass"]?.[0]?.valueLabel },
        { title: "Critical Leave", icon: "calendar-xmark", value: punctualityData?.["Critical Leave"]?.[0]?.valueLabel },
    ]


    return (
        <div className='employee-dash-height' title='Employee Info'>
            {
                loader ? <SkeletonProfile /> : <div style={{ width: "100%", height: "100%" }}>
                    <div className='d-flex justify-content-between mx-0' style={{ width: "100%", height: "22%" }}>
                        <div className='w25 d-flex justify-content-center'>
                            <div>
                                <div style={{
                                    borderRadius: '50%',
                                    padding: '2px',
                                    background: 'conic-gradient(#55B038 0deg 90deg, #F39917 90deg 180deg, #E61B1F 180deg 270deg, #2A8CD4 270deg 360deg)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor:"pointer"
                                }} onClick={() => setViewProfileDialog(true)}>
                                    <img src={userImage} className='employee-img p-0' alt='' style={{ border: '2px solid white', borderRadius: '50%' }} />
                                </div>
                            </div>
                        </div>
                        <div className='w60 text-center'>
                            {
                                users?.length > 1 ? <Dropdown
                                    placeholder="Select"
                                    options={users}
                                    optionLabel='user_display_name'
                                    value={selectedEmployee}
                                    onChange={(e) => setSelectedEmployee(e.target.value === undefined ? loggedInUser : e.target.value)}
                                    filter
                                    filterInputAutoFocus
                                    showClear={selectedEmployee?.user_code === loggedInUser?.user_code ? false : true}
                                /> : <div className='text-truncate' title={selectedEmployee?.user_display_name} style={{ fontSize: "16px", fontWeight: "bold" }}>{selectedEmployee?.user_display_name}</div>
                            }
                            <span style={{ fontWeight: 600, cursor: "default" }} title={skills}>
                                {skills?.length > 15 ? skills?.slice(0, 15) + '...' : skills}
                            </span>
                        </div>
                        <div className='w15 text-right'>
                            <FontAwesomeIcon icon="fa-solid fa-circle-info" className='p-1' style={{ fontSize: "16px", cursor: "pointer" }} onClick={() => setViewProfileDialog(true)} />
                        </div>
                    </div>
                    <p className='team-overview-ptag my-1'>{employeeData?.role_on_project}</p>
                    <div className="row employee-details">
                        {employeeDetails.map(({ label, value, title }) => (
                            <React.Fragment key={label}>
                                <div className="col-6" style={{ fontWeight: 600, fontSize: "12px" }} title={title || ""}>{label}:</div>
                                <div className="col-6" style={{ fontWeight: 400, fontSize: "12px" }}>{value}</div>
                            </React.Fragment>
                        ))}
                    </div>
                    {isLeadDashboard &&
                        <div className='d-flex gap-1 mt-1 justify-content-center'>
                            {punctualityDetails?.map((punc, idx) => (
                                <div key={idx} style={{ padding: "8px 14px" }} className='bg-light rounded w15 d-flex flex-column align-items-center justify-content-center gap-1' title={punc?.title}>
                                    <FontAwesomeIcon icon={`fa-solid fa-${punc?.icon}`} className='text-primary' />
                                    <div style={{ fontSize: "0.70rem" }} className='fw-bold text-truncate' title={punc?.tooltip || ""}>{punc?.value || "-"}</div>
                                </div>
                            ))}
                        </div>
                    }
                    <Dialog className='modal-large profile-dialog' style={{ width: "70%" }} visible={viewProfileDialog} onHide={() => setViewProfileDialog(false)} draggable={false} header="My Profile">
                        <Profile userFromWidget={selectedEmployee} />
                    </Dialog>
                </div>
            }

        </div>
    )
}

export default EmployeInfo